<template>
    <div class="widget px-1 px-md-3 py-1 py-md-2 mw-100">
        <bar-chart
            :height="200"
            :width="280"
            :data="barChart()"
            :options="{
                legend: { display: true },
                position: 'top',
                layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
                responsive: true,
                maintainAspectRatio: false,

                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                            stacked: true,
                        },
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                            stacked: true,
                        },
                    ],
                },
            }"
        >
        </bar-chart>
    </div>
</template>

<script>
import BarChart from "./BarChart";
export default {
    name: "GoalsChart",
    props: ["interval"],
    components: { BarChart },
    data() {
        return {
            labels: [],
            pending: [],
            approved: [],
        };
    },
    created() {
        this.populateLabels();
    },
    watch: {
        interval() {
            this.populateLabels();
        },
    },
    methods: {
        populateLabels() {
            let a = this.moment(this.interval.start).dayOfYear();
            let b = this.moment(this.interval.end).dayOfYear();
            while (a < b) {
                this.labels.push(
                    this.moment()
                        .dayOfYear(a)
                        .format("ddd MMM D")
                        .toUpperCase()
                );
                let x = Math.round(Math.random() * 16);
                let y = x - Math.round(Math.random() * x);
                this.pending.push(x);
                this.approved.push(y);
                a++;
            }
        },
        barChart() {
            return {
                labels: this.labels,
                datasets: [
                    {
                        label: "Approved Days Off",
                        backgroundColor: "#ad68ff",
                        borderColor: "#ad68ff",
                        data: this.approved,
                    },
                    {
                        label: "Pending Days Off Approval",
                        backgroundColor: "#cfbce8",
                        borderColor: "#cfbce8",
                        data: this.pending,
                    },
                ],
            };
        },
    },
};
</script>

<style scoped lang="scss">
.widget {
}
</style>
